import React from 'react';
import IntroSection from './IntroSection';
import CalculatorSection from './CalculatorSection';

export default function HeroSection() {
  return (
    <section className="hero-stage" aria-label="Calculadora de cálcio pela albumina">
      <IntroSection />
      <CalculatorSection />
    </section>
  );
}
